import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '@/assets/app/css/settings.module.css';
import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import TitleHeader from '../common/TitleHeader';
import { ChevronRight } from 'lucide-react';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';
import { openUpdateNicknameSheet } from '@/shared/utils/CommonUtil';

const Settings: React.FC = () => {
  const navigate = useNavigate();
  const { member, logout } = useAppAuthStore();
  const [eventAlarmEnabled, setEventAlarmEnabled] = useState(false);
  const [learningAlarmEnabled, setLearningAlarmEnabled] = useState(true);
  const { openSheet } = useBottomSheetStore();

  const handleBack = () => {
    navigate(-1);
  };

  const snsType = {
    KAKAO: '카카오',
    NAVER: '네이버',
    GOOGLE: '구글',
    APPLE: '애플',
  };

  return (
    <div className="flex flex-col min-h-screen">
      <TitleHeader title="내정보" onBack={() => navigate(-1)} />

      <main>
        {/* 프로필 섹션 */}
        <section className="bg-white rounded-2xl" style={{ padding: '5px 25px 30px' }}>
          <div
            className="flex items-center"
            style={{
              borderTop: '1px solid #F2F2F2',
              borderBottom: '1px solid #F2F2F2',
              padding: '7px 0',
            }}
          >
            <span className="text-[#4B4B4B] text-sm" style={{ width: '30%' }}>
              닉네임
            </span>
            <div className="flex flex-1 items-center justify-between">
              <span className="font-bold">{member?.nickname}</span>
              <button
                className="text-[10px] border rounded"
                onClick={openUpdateNicknameSheet}
                style={{ width: 58, height: 24, border: '1px #E1E1E1 solid' }}
              >
                변경
              </button>
            </div>
          </div>
          <div
            className="flex"
            style={{
              borderBottom: '1px solid #F2F2F2',
              padding: '7px 0',
            }}
          >
            <span className="text-[#4B4B4B] text-sm" style={{ width: '30%' }}>
              이메일
            </span>
            <div className="flex flex-1 items-center justify-between">
              <span className="font-bold">{member?.email}</span>
            </div>
          </div>
          <div
            className="flex"
            style={{
              borderBottom: '1px solid #F2F2F2',
              padding: '7px 0',
            }}
          >
            <span className="text-[#4B4B4B] text-sm" style={{ width: '30%' }}>
              로그인방식
            </span>
            <div className="flex flex-1 items-center justify-between">
              <span className="font-bold">{snsType[member?.snsProviderCode!]}</span>
            </div>
          </div>
        </section>
      </main>

      <div style={{ width: '100%', height: 14, backgroundColor: '#F2F2F2' }}></div>

      <main style={{ padding: 25 }}>
        {/* 알림 설정 */}
        {/* <section className="bg-white rounded-2xl p-2" style={{ border: '1px #E5E5E5 solid' }}>
          <div className="flex justify-between items-center p-2">
            <span className="font-bold text-sm">이벤트 알림</span>
            <Toggle checked={false} />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div className="flex justify-between items-center p-2">
            <div>
              <p className="font-bold text-sm">연속도전 알림</p>
              <p className="text-[10px] text-gray-400">매일 오전 10시 연속도전하고 포인트 받기</p>
            </div>
            <Toggle checked={true} />
          </div>
        </section> */}

        {/* 메뉴 리스트 */}
        <section className="bg-white rounded-2xl p-2" style={{ border: '1px #E5E5E5 solid' }}>
          <div
            className="flex justify-between items-center p-2"
            onClick={() => openSheet('message', { type: 'ALERT', message: '이벤트 준비중입니다.' })}
          >
            <span className="font-bold text-sm">이벤트</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div
            className="flex justify-between items-center p-2"
            onClick={() => navigate('/mypage/faq')}
          >
            <span className="font-bold text-sm">자주 묻는 질문</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div className="flex justify-between items-center p-2">
            <span className="font-bold text-sm">서비스 이용약관</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div
            className="flex justify-between items-center p-2"
            onClick={() => navigate('/mypage/sources')}
          >
            <span className="font-bold text-sm">자료출처</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div className="flex justify-between items-center p-2">
            <span className="text-sm">앱 버전 정보</span>
            <span style={{ color: '#14A1C8' }}>v1.0.0(251017)</span>
          </div>
        </section>
        <section
          className="bg-white rounded-2xl p-2"
          style={{ border: '1px #E5E5E5 solid', marginTop: 15 }}
        >
          <div
            className="flex justify-between items-center p-2"
            onClick={() =>
              openSheet('message', {
                type: 'CONFIRM',
                message: '로그아웃 하시겠습니까?',
                onConfirm: logout,
              })
            }
          >
            <span className="font-bold text-sm">로그아웃</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
          <hr className="mx-auto w-[92%]" style={{ color: '#F2F2F2' }} />
          <div
            className="flex justify-between items-center p-2"
            onClick={() => openSheet('delete-member', { showHeader: true, title: '계정 삭제하기' })}
          >
            <span className="font-bold text-sm">계정 삭제하기</span>
            <ChevronRight className="w-6 h-6 text-[#4B4B4B]" />
          </div>
        </section>
      </main>
    </div>
  );
};

// 간단한 토글 컴포넌트
const Toggle = ({ checked }: { checked: boolean }) => (
  <div
    className={`w-12 h-6 rounded-full p-1 transition-colors ${checked ? 'bg-cyan-500' : 'bg-gray-300'}`}
  >
    <div
      className={`w-4 h-4 bg-white rounded-full transition-transform ${checked ? 'translate-x-6' : 'translate-x-0'}`}
    />
  </div>
);

export default Settings;
